import CartModal, { CartModalProps } from './CartModal'
import withInteractor from './CartModal.interactor'
import withPresenter from './CartModal.presenter'

export type { CartModalProps }
export default withInteractor(withPresenter(CartModal))
